import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';

const IssueReturnItemView = ({ itemData, currencyPrecision }) => {

    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className='dynoTable' >
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Inventory UOM</th>
                            <th>Unit Price</th>
                            <th>Amount</th>
                            <th>CGS Acc</th>
                            <th>CGS Acc Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemData?.issueReturnDetails?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.srno} disabled style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemCode} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'>
                                    <input
                                        className='p-2' style={{ width: "150px" }}
                                        type="number"
                                        value={row.qty}
                                        disabled
                                    />
                                </td>
                                <td className='m-0 p-0'><input className='p-2' value={row.uom} disabled style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.unitPrice || 0).toFixed(currencyPrecision || 0) || 0} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.cgsAccountName || 0} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.cgsAccountCode || 0} style={{ width: "150px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default IssueReturnItemView;